import {
  debounce,
  stripHTML,
} from '../../common/Utils';
import KeyCodes from '../../common/KeyCodes';
import {
  getAISUrlParameter,
  getMainStoreInstance,
  getDefaultIndex,
  getMainHelper,
  mainStoreName,
  getIndexKey,
  getUrlKeys,
  getIndex,
  widgets,
  setAISReset,
  setAISRun,
  aisCloseEvent,
  aisSearchEvent,
  clearRefinementHandler,
  isDefaultRefinements,
} from '../../common/Algolia';
import { getResultPanel } from './algolia-hits';
import { instantSearchLoaderInit } from '../../common/molecule/loader-instant-search';
import { openAddToBagPopin } from '../../common/organism/popin.addtobag';
import GlobalVars from '../../common/GlobalVars';
import * as header from '../organism/header';
import {
  scrollLocked,
  scrollUnlocked,
} from '../../common/template/page';
import {
  triggerAlgoliaProductListShownEvent,
} from '../../common/Events';
import {
  clearData as clearDataLayerNextPageData,
} from '../../common/DataLayerNextPage';
import {
  getItemName,
  getItemPrice,
  getItemBrand,
  getItemCategory,
  getItemVariant,
  getItemClass,
  getItemListName,
} from '../../common/organism/product-thumbnails-module';
import { filledClass } from './search';

// Constants (ids)
const searchAreaId = 'searchArea';
const searchFieldId = 'searchField';
const magnifierButtonId = 'btnSearch';
const cancelButtonId = 'btnCancel';
const dataSkuAttr = 'data-ocms-thumb-sku';

const dicoSearchKey = 'search';
const dicoCancelKey = 'cancel';

// Constants (classes)
const pristineClass = 'pristine';
const panelOpenClass = 'ais-open';
const slideOpenClass = 'slide-open';
const loaderContainerClass = 'ais-search-box--loading-indicator-wrapper';
const loaderIndicatorClass = 'ais-search-box--loading-indicator';
const magnifierWrapperClass = 'ais-search-box--magnifier-wrapper';
const cancelWrapperClass = 'ais-search-box--reset-wrapper';
const accountHeaderClass = 'o-account-header-customer';

// Constant url params names
const urlKeys = getUrlKeys();
const isLandingSearch = GlobalVars.isSearchPage;

let $resultPanel;


let lastSearchedUrl = '';

/* Store instance */
let occStore;
let helper;

/* Dico related props */
let dicoSearch;
let dicoCancel;

/* DOM elements use as starting points */
let $searchArea;
let $searchField;

/* Those waiting templates rendering (render event) */
let $searchButton;
let $btnCancelSearch;
let $magnifierWrapper;
let $cancelWrapper;

let showTheLoader;
let searchKeyword = '';
let resultsData = '';
let nextPage = false;
let isAISCancel = false;

let algoliaListShownEventTimer;

/* Search input debouncer */
const delayedSearch = debounce((event, q, fSearch) => {
  if (q.trim() !== '') {
    $searchArea.addClass(filledClass);
    fSearch(q);
  }
}, 300);

function hideLoader() {
  scrollUnlocked();
  $(`.${loaderIndicatorClass}, .${loaderContainerClass}`).hide();
}

function showLoader() {
  scrollLocked();
  $(`.${loaderIndicatorClass}, .${loaderContainerClass}`).show();
}

function handleLoader() {
  if (isLandingSearch) {
    setTimeout(hideLoader, 500);
  }

  helper.on('search', () => {
    // Show loader if the response from algolia takes more than 500ms
    showTheLoader = setTimeout(showLoader, 500);
  });

  helper.on('searchQueueEmpty', () => {
    // Hide the loader once the search queue is empty
    clearTimeout(showTheLoader);
  });

  helper.on('result', () => {
    // Hide loader no matter what
    hideLoader();
  });
}

// triggerAlgoliaProductThumbnailClickedEvent when a product list is displayed in an instant search product list panel
function triggerProductListShown(results, anFromIndex, query) {
  let productsDataList = [];
  searchKeyword = query;

  results.forEach((aoProductData, anIndex) => {
    const $elem = $(`[${dataSkuAttr}="${aoProductData.sku}"]`);

    productsDataList.push({
      id: aoProductData.id,
      name: getItemName($elem),
      price: getItemPrice($elem),
      position: anFromIndex + anIndex + 1,
      brand: getItemBrand($elem),
      category: getItemCategory($elem),
      variant: getItemVariant($elem),
      productClass: getItemClass($elem),
      list: getItemListName($elem),
    });
  });

  // Strip all HTML in one hit
  productsDataList = JSON.parse(stripHTML(JSON.stringify(productsDataList)));

  // Fill next page datalayer with fresh datas
  triggerAlgoliaProductListShownEvent(productsDataList, searchKeyword, true, false);

  if (algoliaListShownEventTimer != null) {
    // Clear existing "Algolia list shown" event timer
    clearTimeout(algoliaListShownEventTimer);
  }

  // Trigger event only 10 seconds after the last user input
  algoliaListShownEventTimer = setTimeout(
    () => {
      triggerAlgoliaProductListShownEvent(productsDataList, searchKeyword, nextPage, isLandingSearch);
      algoliaListShownEventTimer = null;
    }
    , 10000
  );
}

/* Return a refinement state object stripped of default refinements (e.g. off/online date) */
function prepareUrlRefinements(refinements) {
  const filteredRefinements = refinements;

  Object.keys(filteredRefinements).forEach((facet) => {
    if (isDefaultRefinements(facet)) {
      delete filteredRefinements[facet];
    }
  });

  return filteredRefinements;
}

/* Build the redirection url to result page to keep a consistent user experience */
function setupLandingSearch() {
  try {
    clearDataLayerNextPageData();

    const state = helper.getState();
    const strippedNumericRefinements = prepareUrlRefinements(state.numericRefinements);

    const tempLiteralRefinements = ($.isEmptyObject(state.disjunctiveFacetsRefinements) !== true) ? JSON.stringify(state.disjunctiveFacetsRefinements) : '';
    const tempNumericRefinements = ($.isEmptyObject(strippedNumericRefinements) !== true) ? JSON.stringify(strippedNumericRefinements) : '';
    const query = encodeURIComponent($searchField.val()); // The only argument acreated on every redirection
    const index = (state.index !== getDefaultIndex(mainStoreName)) ? `&${urlKeys.index}=${encodeURIComponent(getIndexKey(state.index))}` : '';
    const page = (state.page > 0) ? `&${urlKeys.page}=${encodeURIComponent(state.page)}` : '';
    const literalRefinements = (tempLiteralRefinements !== '') ? `&${urlKeys.literalRefinements}=${encodeURIComponent(tempLiteralRefinements)}` : '';
    const numericRefinements = (tempNumericRefinements !== '') ? `&${urlKeys.numericRefinements}=${encodeURIComponent(tempNumericRefinements)}` : '';
    const sUrl = `/V2/pages/common/Search.aspx?${urlKeys.query}=${query}&c=${GlobalVars.C}&l=${GlobalVars.L}${index}${page}${literalRefinements}${numericRefinements}`;

    if (isLandingSearch && (lastSearchedUrl !== sUrl)) {
      history.replaceState(null, '', sUrl); // No page refresh
      lastSearchedUrl = sUrl;
    } else if (!isLandingSearch) {
      location.href = sUrl; // Redirection
    }
  } catch (error) {
    console.error('===== Result page configuration interrupted =====', error);
  }
}

/* Get the url parameters and configure the store state to get back UI configuration */
function processUrlParameters() {
  try {
    const tempLiteralRefinements = getAISUrlParameter(urlKeys.literalRefinements);
    const tempNumericRefinements = getAISUrlParameter(urlKeys.numericRefinements);
    const literalRefinements = (tempLiteralRefinements !== '') ? JSON.parse(tempLiteralRefinements) : '';
    const numericRefinements = (tempNumericRefinements !== '') ? JSON.parse(tempNumericRefinements) : '';
    const currentIndex = getIndex(getAISUrlParameter(urlKeys.index));

    occStore.searchParameters.index = ($.isEmptyObject(currentIndex) !== true) ? currentIndex.index : getDefaultIndex(mainStoreName);
    occStore.searchParameters.query = getAISUrlParameter(urlKeys.query) || '';
    occStore.searchParameters.page = getAISUrlParameter(urlKeys.page) || 0;
    if (literalRefinements !== '') { occStore.searchParameters.disjunctiveFacetsRefinements = literalRefinements; }
    if (numericRefinements !== '') { occStore.searchParameters.numericRefinements = numericRefinements; }

    lastSearchedUrl = location.href;

    if (occStore.searchParameters.query !== '') {
      $searchArea.addClass(filledClass);
      $searchField.removeClass(pristineClass);
    }

    setAISRun(mainStoreName);
  } catch (error) {
    console.error('===== Landing page setup incomplete =====', error);
  }
}

function closePanel() {
  const $accountHeader = $(`.${accountHeaderClass}`);

  // Reset field value and query state
  helper = getMainHelper();
  $searchField
    .val('')
    .addClass(pristineClass);

  setAISReset(mainStoreName);
  helper
    .setQuery('')
    .setPage(0)
    .clearRefinements(clearRefinementHandler)
    .setIndex(getDefaultIndex(mainStoreName));

  $cancelWrapper.hide();
  $magnifierWrapper.fadeIn('fast');

  $cancelWrapper.hide();
  $magnifierWrapper.fadeIn('fast');

  if (!isLandingSearch) {
    /* Adjust site initial padding */
    $(`#${header.siteId}`).css('margin-top', 'initial');

    /* Show main nav */
    $('#mainNav').attr({
      style: '',
      'aria-hidden': false,
    });

    /* Show account header */
    if ($accountHeader.length > 0) {
      $accountHeader.attr({
        style: 'display: block;',
        'aria-hidden': false,
      });
    }

    /* Show addToBag popin (e.g. product page) */
    openAddToBagPopin();

    /* Show overlay and loader only if background process still running */
    if (typeof OCMS.Popin !== 'undefined' && OCMS.Popin.isOpened === true && OCMS.Popin.current.options.id === 'loadingPopin') {
      if (typeof showLoading === 'function') { showLoading(false, false); } // eslint-disable-line no-undef
    }

    /* Hide result panel */
    $resultPanel
      .removeClass(panelOpenClass)
      .attr('aria-hidden', true)
      .siblings('[class*="banner"], #content')
      .fadeIn('fast');
  }

  /* Smooth scroll top */
  $('html,body').animate({ scrollTop: 0 }, 500);

  /* Preventing default response result slide down */
  setTimeout(() => {
    setAISRun(mainStoreName);
  }, 800);
}

/* Register events after the rendering */
function searchBoxEventSetup() {
  if (typeof occStore !== 'undefined') {
    occStore.once('render', () => {
      const $document = $(document);

      /* Prevent autocomplete (e.g. signin autocomplete problem) */
      $searchField
        .on('focus', (e) => {
          $(e.target).removeAttr('readonly');
        })
        .on('blur', (e) => {
          $(e.target).attr('readonly', true);
        });

      helper = getMainHelper();
      $resultPanel = getResultPanel();
      handleLoader();

      /* Declare handler for custom event triggered in queryHook method (e.g. debounce user input) */
      $document.on(aisSearchEvent, delayedSearch);

      $searchButton = $(`#${magnifierButtonId}`);
      $btnCancelSearch = $(`#${cancelButtonId}`);
      $magnifierWrapper = $searchButton.closest(`.${magnifierWrapperClass}`);
      $cancelWrapper = $btnCancelSearch.closest(`.${cancelWrapperClass}`);

      /* Recover anim when page load on sticky header version */
      $searchButton.on('click', () => {
        if ($(`#${header.headerId}`).hasClass(header.miniClass) && !$searchArea.hasClass(slideOpenClass)) {
          $searchArea.addClass(slideOpenClass);

          window.setTimeout(() => {
            $searchField.focus();
          }, 500);
        } else {
          nextPage = true;

          /* Setup URL parameter before redirection */
          setupLandingSearch();
        }
      });

      $btnCancelSearch.on('click', () => {
        isAISCancel = true;
        $document.trigger(aisCloseEvent);
      });

      // Forbid some characters to prevent server error
      $searchField.on('keydown', (event) => {
        if (event.keyCode === KeyCodes.chevron) {
          /* Prevent default submition and bubbling to "keypress" */
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      });

      $searchField.on('keypress', (event) => {
        if (event.keyCode === KeyCodes.enter) {
          /* Prevent default submition to main form controller */
          event.preventDefault();
          event.stopImmediatePropagation();

          nextPage = true;

          /* Setup URL parameter before redirection */
          setupLandingSearch();
        }
      });

      /* Handle Algolia panel closing at document root level */
      $document.on(aisCloseEvent, (event) => {
        event.stopImmediatePropagation();
        closePanel();

        if (isLandingSearch) {
          setupLandingSearch();

          if (isAISCancel === false) {
            helper.search();
          }
        }

        isAISCancel = false;
      });

      $document.on('keyup', (event) => {
        if (event.keyCode === KeyCodes.esc && $resultPanel.hasClass(panelOpenClass)) { // Echap
          $document.trigger(aisCloseEvent);
        }
      });

      $searchField.on('keyup', (event) => {
        const $field = $(event.target);

        if ($field.val().trim() !== '') {
          $field.removeClass(pristineClass);
          $magnifierWrapper.hide();
          $cancelWrapper.show();
        } else if ($resultPanel.hasClass(panelOpenClass)) {
          $document.trigger(aisCloseEvent);
        }
      });

      $searchField.on('focus', (event) => {
        $(event.target).closest(`#${searchAreaId}`).addClass('focused');
      });

      $searchField.on('blur', (event) => {
        $(event.target).closest(`#${searchAreaId}`).removeClass('focused');
      });

      helper.on('search', () => {
        if (isLandingSearch) {
          setupLandingSearch();
        }
      });

      helper.on('result', (results) => {
        resultsData = results.hits;
        const query = encodeURIComponent($searchField.val()); // The only argument acreated on every redirection
        if (query !== '') {
          // Fire trigger product list shown KPI 26 TER (old KPI 71)
          if (!nextPage) {
            triggerProductListShown(resultsData, 0, query);
          }
        }
      });
    });
  } else {
    console.error('Missing Algolia store connection.');
  }
}

/* Searchbox wideget setup */
function searchBoxInit() {
  /* Init elements */
  $searchArea = $(`#${searchAreaId}`);
  $searchField = $(`#${searchFieldId}`);

  if ($searchArea.length > 0) {
    /* Get store instance */
    occStore = getMainStoreInstance();

    try {
      dicoSearch = OCMS.aisPanel.dicoKeys[dicoSearchKey];
      dicoCancel = OCMS.aisPanel.dicoKeys[dicoCancelKey];
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-SEARCH =====', error);
    }

    occStore.addWidget(
      widgets.searchBox({
        container: $searchField[0], // Expect a vanilla DOM object
        placeholder: dicoSearch,
        autofocus: false, // Only to avoid live preview taking focus
        wrapInput: false,
        magnifier: {
          cssClasses: { root: 'a-btn m-search-internal-search__btn' },
          template: data => `<button id="${magnifierButtonId}" class="${data.cssClasses.root}" type="button">
                               <span class="sr-only">${dicoSearch}</span>
                               <i class="a-icon a-icon--search m-search-internal-search__icon" aria-hidden="true"></i>
                             </button>`
        },
        reset: {
          cssClasses: { root: 'a-btn m-search-internal-search__btn' },
          template: data => `<button id="${cancelButtonId}" class="${data.cssClasses.root} m-search-internal-search__btn-close" type="button">
                               <span class="sr-only">${dicoCancel}</span>
                               <i class="m-search-internal-search__btn-close-icon a-icon a-icon-css a-icon-css--cross-close m-search-internal-search__icon" aria-hidden="true"></i>
                             </button>`
        },
        loadingIndicator: false,
        queryHook: (query, search) => {
          $(document).trigger(aisSearchEvent, [query, search]);
        },
      })
    );

    /* Setup widget events after the "render" completion */
    searchBoxEventSetup();

    /* Init loader after the render */
    instantSearchLoaderInit();

    /* Hide loader at loading */
    if (!isLandingSearch) {
      hideLoader();
    }

    /* Catch url paramater if they exist */
    if (isLandingSearch) {
      processUrlParameters();
    }

    return true;
  }

  return false;
}

// Named exports
export default searchBoxInit;



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-search-box.js